import styles from "./style.module.scss";
import AboutImage from "src/assets/facility_about.jpg";

export const AboutSection = () => {
  return (
    <section className={styles.container}>
      <div className={styles.innerBox}>
        <h2>石巻マリンヴィレッジ​​について</h2>
        <p>
          石巻マリンヴィレッジは、株式会社あいホームが石巻市新館地区で展開するコミュニティ型分譲地です。サーフィンや釣りが好きな人の暮らしやすさにこだわって設計し、かつ設備や時間を共有していくことで、理想のライフスタイルを共創していくことを目指しています。また、建売住宅や賃貸住宅と同じ敷地の中に宿泊棟があり、地域の暮らしに溶け込むような体験ができます。
        </p>
        <img src={AboutImage} alt="Facility About" />
      </div>
    </section>
  );
};
